import {
  CREATE_ORDER_PENDING,
  CREATE_ORDER_FULFILLED,
  CREATE_ORDER_REJECTED,
  FETCH_ORDERS_PENDING,
  FETCH_ORDERS_FULFILLED,
  FETCH_ORDERS_REJECTED,
  GET_ORDER_PENDING,
  GET_ORDER_FULFILLED,
  GET_ORDER_REJECTED,
  GET_ORDER_ENQUIRY_PENDING,
  GET_ORDER_ENQUIRY_FULFILLED,
  GET_ORDER_ENQUIRY_REJECTED,
  GET_INVOICE_PDF_PENDING,
  GET_INVOICE_PDF_FULFILLED,
  GET_INVOICE_PDF_REJECTED,
} from "../actions/order";

const initialState = {
  fetching: false,
  orderEnquiry: false,
  errors: [],
  orders: [],
  order: null,
  invoicePdf: null,
  fetchingInvoicePdf: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER_ENQUIRY_PENDING:
      return {
        ...state,
        fetching: true,
      };
    case GET_ORDER_ENQUIRY_FULFILLED:
      return {
        ...state,
        fetching: false,
        orderEnquiry: action.payload,
      };
    case GET_ORDER_ENQUIRY_REJECTED:
      return {
        ...state,
        fetching: false,
      };

    case GET_ORDER_PENDING:
      return {
        ...state,
        fetching: true,
      };
    case GET_ORDER_FULFILLED:
      return {
        ...state,
        fetching: false,
        order: action.payload,
      };
    case GET_ORDER_REJECTED:
      return {
        ...state,
        fetching: false,
      };
    case FETCH_ORDERS_PENDING:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_ORDERS_FULFILLED:
      return {
        ...state,
        fetching: false,
        orders: action.payload,
      };
    case FETCH_ORDERS_REJECTED:
      return {
        ...state,
        fetching: false,
      };
    case CREATE_ORDER_PENDING:
      return {
        ...state,
        fetching: true,
        pending: true,
        errors: [],
        error: null,
      };
    case CREATE_ORDER_FULFILLED:
      return {
        ...state,
        fetching: false,
        pending: false,
        item: action.payload,
        errors: [],
        error: null,
      };
    case CREATE_ORDER_REJECTED:
      return {
        ...state,
        fetching: false,
        pending: false,
        errors: action.payload || [],
        error: action.payload || null,
      };
    case GET_INVOICE_PDF_PENDING:
      return {
        ...state,
        fetchingInvoicePdf: true,
        invoicePdf: null,
      };
    case GET_INVOICE_PDF_FULFILLED:
      return {
        ...state,
        fetchingInvoicePdf: false,
        invoicePdf: action.payload,
      };
    case GET_INVOICE_PDF_REJECTED:
      return {
        ...state,
        fetchingInvoicePdf: false,
        invoicePdf: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/orderReducer.js